
export default class JiraCloudClient {
}

JiraCloudClient.isCloudEnv = () => false;

